import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { BUSINESS } from "../constants";

export const Footer = ({ t }) => {
  return (
    <footer
      className="relative bg-[#05080F] border-t border-white/10 px-5 md:px-8 lg:px-12 py-12 md:py-14"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo size="md" showSubtitle />
          <p className="text-white/50 text-sm mt-4 max-w-xs leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="space-y-3 text-sm">
          <div className="flex items-start gap-3">
            <MapPin className="w-4 h-4 text-[#E63946] mt-0.5 flex-shrink-0" />
            <a
              href={BUSINESS.mapsLink}
              target="_blank"
              rel="noreferrer"
              className="text-white/70 hover:text-white transition-colors break-words"
              data-testid="footer-address-link"
            >
              {BUSINESS.address}
            </a>
          </div>
          <div className="flex items-start gap-3">
            <Phone className="w-4 h-4 text-[#E63946] mt-0.5 flex-shrink-0" />
            <a
              href={BUSINESS.phoneHref}
              className="text-white/70 hover:text-white transition-colors"
              data-testid="footer-phone-link"
            >
              {BUSINESS.phone}
            </a>
          </div>
          <div className="flex items-start gap-3">
            <Mail className="w-4 h-4 text-[#E63946] mt-0.5 flex-shrink-0" />
            <a
              href={BUSINESS.emailHref}
              className="text-white/70 hover:text-white transition-colors break-all"
              data-testid="footer-email-link"
            >
              {BUSINESS.email}
            </a>
          </div>
          <div className="flex items-start gap-3">
            <MessageCircle className="w-4 h-4 text-[#E63946] mt-0.5 flex-shrink-0" />
            <a
              href={BUSINESS.whatsappHref}
              target="_blank"
              rel="noreferrer"
              className="text-white/70 hover:text-white transition-colors"
              data-testid="footer-whatsapp-link"
            >
              WhatsApp
            </a>
          </div>
        </div>

        <div className="flex flex-col md:items-end gap-3 text-sm">
          <Link
            to="/impressum"
            className="text-white/60 hover:text-white transition-colors font-heading uppercase tracking-wider text-xs"
            data-testid="footer-imprint"
          >
            {t.footer.imprint}
          </Link>
          <Link
            to="/datenschutz"
            className="text-white/60 hover:text-white transition-colors font-heading uppercase tracking-wider text-xs"
            data-testid="footer-privacy"
          >
            {t.footer.privacy}
          </Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/5 text-xs text-white/40 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <span>
          © {new Date().getFullYear()} YOUR CUT Hamburg. {t.footer.rights}
        </span>
        <span className="font-script italic text-white/40">
          Handcrafted in Hamburg
        </span>
      </div>
    </footer>
  );
};
